export interface ServiceDueButtonDataModel {
  name: string;
  isActive: boolean;
}